import { combineReducers } from 'redux'
import authreducer from "./auth"
import loadingreducer from "./loading"
import userreducer from "./user"
import toastreducer from './toast'
import onboardingreducer from './onboarding'
import projectsreducer from './projects'
import walletreducer from "./wallet"
import modalreducer from "./modal"
import ticketsreducer from "./tickets"
import ccsreducer from "./ccs"

const reducer = combineReducers({
    authreducer,
    loadingreducer,
    userreducer,
    onboardingreducer,
    toastreducer,
    projectsreducer,
    ticketsreducer,
    walletreducer,
    modalreducer,
    ccsreducer
})

export default reducer